var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("welcome to the main page "+_vm._s(this.uid))]),_c('p',[_vm._v("hello "+_vm._s(this.user.username))]),_c('p',[_vm._v("Welcome back "+_vm._s(this.user.firstName))])])}
var staticRenderFns = []

export { render, staticRenderFns }